import React from 'react'

function CustomTable(props) {
	const {
		columns = [],
		dataSource = [],
		style = {},
		scroll = { x: false, y: false },
		bordered = false,
		rowClassName = () => { },
		className = '',
		isShowTitle = true,
	} = props

	return (
		<div
			style={{
				...style,
				overflowX: scroll.x ? 'auto' : 'hidden',
				overflowY: scroll.y ? 'auto' : 'hidden',
			}}
			className={`container-table-event ${className}`}
		>
			<table className="container-table-event-table" border={bordered ? 1 : 0}>
				{isShowTitle ? (
					<thead>
						<tr>
							{columns.map((item, i) => (
								<th
									style={{ textAlign: item.align, width: item.width }}
									key={`head_index_${i}`}
								>
									{item.title}
								</th>
							))}
						</tr>
					</thead>
				) : null}

				<tbody>
					{dataSource.map((item, index) => {
						let className = rowClassName(item, index)
						return (
							<tr key={`body_index_${index}`} className={className}>
								{columns.map((_it, _i) => {
									return (
										<td
											key={`body_index_item_${_i}`}
											style={{ textAlign: _it.align, width: _it.width }}
										>
											{typeof _it?.render === 'function'
												? _it.render(item[_it.dataIndex], item)
												: item[_it.dataIndex]}
										</td>
									)
								})}
							</tr>
						)
					})}
				</tbody>
			</table>
		</div>
	)
}

export default CustomTable
